import React from "react"

export const BookDemo = () => {
  React.useEffect(() => {
    const hubspotScript = document.createElement("script")

    hubspotScript.src =
      "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
    hubspotScript.async = true

    document.body.appendChild(hubspotScript)
  }, [])
  return (
    <div
      style={{ width: "100%" }}
      className={"meetings-iframe-container"}
      data-src="https://meetings.hubspot.com/info10880?embed=true"
    />
  )
}
